import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';

import 'video.js/dist/video-js.css'

Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(VueI18n);
const LANGUAGE_INIT_KEY = 'lang_initialized';
const SUPPORTED_LANGUAGES = [
  'zh_cn',
  'en_us',
  'ms_my',
  'ko_hy',
  'es_spa',
  'yn_yu',
  'idn_yu',
  'ja_jp',
];
const defaultLang = process.env.VUE_APP_DEFAULT_LANG || 'ja_jp';
const storedLang = localStorage.getItem('lang');
const hasInitializedLang = localStorage.getItem(LANGUAGE_INIT_KEY) === '1';
const langtt = hasInitializedLang && SUPPORTED_LANGUAGES.includes(storedLang) ? storedLang : defaultLang;

if (storedLang !== langtt) {
  localStorage.setItem('lang', langtt);
}
if (!hasInitializedLang) {
  localStorage.setItem(LANGUAGE_INIT_KEY, '1');
}

const i18n = new VueI18n({
  globalInjection: true, 
  locale: langtt, // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
    'zh_cn': require('./assets/languages/zh_cn.json'),
    'en_us': require('./assets/languages/en_us.json'),
    'ms_my': require('./assets/languages/ms_my.json'),
  'ko_hy': require('./assets/languages/ko_hy.json'),

  
	'es_spa': require('./assets/languages/es_spa.json'),
  'yn_yu': require('./assets/languages/yn_yu.json'),
  'idn_yu': require('./assets/languages/idn_yu.json'),
  'ja_jp': require('./assets/languages/ja_jp.json'),
  }
});
new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
